/*!

=========================================================
* Material Dashboard React - v1.10.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/* eslint-disable */
import { React, Fragment, Component } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom"; // eslint-disable-line no-unused-vars

import CircularIndeterminate from 'components/Spinner.js';
import Box from '@material-ui/core/Box';

// core components
import Admin from "layouts/Admin.js";
// import RTL from "layouts/RTL.js"; // eslint-disable-line no-unused-vars

import Page404 from "views/Pages/Page404.js"; // eslint-disable-line no-unused-vars
import Page500 from "views/Pages/Page500.js"; // eslint-disable-line no-unused-vars
import Login from "views/Pages/Login.js";
import PickingList from "views/StockJobs/PickingList";

import "assets/css/material-dashboard-react.css?v=1.10.0";


//const hist = createBrowserHistory();

class CheckLoggedIn extends Component {
  constructor(props) {
    super(props);

    this.state = {
      waitingForAuth: true,
      user: null,
    }
  }

  componentDidMount() {
    // this.state.socket.on('login', user => this.setState({ user, waitingForAuth: false }));
    // this.state.socket.on('error', err => this.setState({ user: null, waitingForAuth: false }));
    var $this = this;
    fetch('/api/shared/reissue', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({jwt:""})
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if (data.status.success) {
          $this.setState({
            user: data.data.user,
            waitingForAuth: false
          })
        }
        else {
          $this.setState({
            user: null,
            waitingForAuth: false
          })
        }
      });
  }

  render() {
    return (
      <Fragment>
        {
          this.state.waitingForAuth ?
            <Box display='flex' alignItems='center'>
              <CircularIndeterminate />
            </Box>
            :
            // <BrowserRouter history={hist}>
            <BrowserRouter>
              {this.state.user ?
                <Switch>
                  <Route path="/portal" render={props => <Admin {...props} user={this.state.user} />} /> 
                  {/* <Route path="/portal" component={Admin} /> */}
                  <Route path="/404" component={Page404} />
                  <Route path="/500" component={Page500} />
                  <Route path="/pickingList/:code" component={PickingList} />
                  <Redirect exact from="/" to="/portal" />
                  <Route component={Page404} />
                </Switch>
                :
                <Switch>
                  <Route path="/login" component={Login} />
                  <Route component={Login} />
                </Switch>
              }
            </BrowserRouter>
        }
      </Fragment>
    );
  }
}

ReactDOM.render(
  <Fragment>
    <CheckLoggedIn />
    {/* <BrowserRouter>
      <Switch>
        <Route path="/admin" component={Admin} />
        <Route path="/rtl" component={RTL} />
        <Redirect from="/" to="/admin/dashboard" />
        <Route component={Login} />
      </Switch>
    </BrowserRouter> */}
  </Fragment>,
  document.getElementById("root")
);
